import { useTranslation } from 'react-i18next'

import { Box, Button, Grid, Typography } from '@mui/material'

import { COMPONENT_EXTENDER } from 'extender'

import { useStyles } from './styles'

const SingleContainerLayoutComponent = COMPONENT_EXTENDER('components/layouts/SingleContainerLayout')

const ErrorServer500 = () => {
    const { classes } = useStyles({ errorCode: 500 })
    const { t } = useTranslation()

    return (
        <SingleContainerLayoutComponent disableGoBack>
            <Box className={classes.errorContainer} data-sta-id="error-500">
                <Grid container className="errorWrap">
                    <Grid item sm={12} md={5} className="img" />
                    <Grid item sm={12} md={7} className="card">
                        <div className="content">
                            <Typography className="title">{t('ErrorBoundary.ErrorServer500.Title')}</Typography>
                            <Typography>{t('ErrorBoundary.ErrorServer500.ErrorMsg')}</Typography>
                            <Button
                                type="button"
                                className="button"
                                variant="contained"
                                color="primary"
                                onClick={() => window.location.replace('/')}
                            >
                                {t('ErrorBoundary.ErrorServer500.RefreshPage')}
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        </SingleContainerLayoutComponent>
    )
}

export default ErrorServer500

